module.exports = __webpack_public_path__ + "static/media/thunderstorm-icon.d25e870f.svg";